(function () {
var $de3ce1946904c6e7$var$lib = {
    selectors: {
        tileCtr: '.customer__tiles',
        tile: '.tile'
    }
};
var $de3ce1946904c6e7$var$showEl = function(el) {
    return el.hidden = false;
};
var $de3ce1946904c6e7$var$hideEl = function(el) {
    return el.hidden = true;
};
document.addEventListener('mcflyFilterChange', function(event) {
    var tileContainer = document.querySelector($de3ce1946904c6e7$var$lib.selectors.tileCtr);
    var allTiles = tileContainer.querySelectorAll($de3ce1946904c6e7$var$lib.selectors.tile);
    allTiles.forEach(function(tile) {
        if (!event.detail.filterValue) $de3ce1946904c6e7$var$showEl(tile);
        else {
            var tileCategories = tile.getAttribute('data-cat').split(' ');
            if (!tileCategories.includes(event.detail.filterValue)) $de3ce1946904c6e7$var$hideEl(tile);
            else $de3ce1946904c6e7$var$showEl(tile);
        }
    });
    if (Array.from(allTiles).filter(function(tile) {
        return !tile.hidden;
    }).length === 0) $de3ce1946904c6e7$var$hideEl(tileContainer);
    else $de3ce1946904c6e7$var$showEl(tileContainer);
});

})();
//# sourceMappingURL=customer_tiles.min.js.map
